export const getFingerprint = () => {
    let fp = localStorage.getItem('hb_fp');
    if (!fp) {
        try {
            const arr = new Uint8Array(16);
            window.crypto.getRandomValues(arr);
            fp = Array.from(arr, b => b.toString(16).padStart(2, '0')).join('');
        } catch {
            fp = Math.random().toString(36).slice(2) + Date.now().toString(36);
        }
        localStorage.setItem('hb_fp', fp);
    }
    return fp;
};
